const request = {}

request.createRequest = function (transferAccountData) {
  return {
    name: transferAccountData.name,
    defaultCurrencyId: transferAccountData.defaultCurrency
      ? transferAccountData.defaultCurrency.value
      : null,
    sortNumber: transferAccountData.sortNumber
  }
}
export default { request }
